import './style.less';

export default function() {
  const vm = this;

  vm.moveRight = option => {
    if (!option) return;
    vm.ngModel.push(option);
    vm.options.splice(vm.options.indexOf(option), 1);
  };

  vm.moveLeft = model => {
    if (!model) return;
    vm.options.push(model);
    vm.ngModel.splice(vm.ngModel.indexOf(model), 1);
  };

  vm.moveAllRight = () => {
    vm.ngModel.push(...angular.copy(vm.options));
    vm.options.length = 0;
  };

  vm.moveAllLeft = () => {
    vm.options.push(...angular.copy(vm.ngModel));
    vm.ngModel.length = 0;
  };
}



// WEBPACK FOOTER //
// ./src/app/components/forms/dualListBox/controller.js